import * as React from 'react';
import './skeleton.scss';

export enum ESkeletonType {
    DARK,
    LIGHT,
}

export interface ISkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
    /**
     * Тип скелетона - темный или светлый.
     */
    type?: ESkeletonType;
}

/**
 * Элемент для визуализации содержимого, которое еще не загрузилось.
 */
export const Skeleton: React.FC<ISkeletonProps> = ({className, type = ESkeletonType.DARK, ...htmlDivAttributes}) => (
    <div
        className="skeleton dark"
        {...htmlDivAttributes}
    />
);